<template>
  <div class="ka-kpi" :class="{ 'ka-kpi--highlight': highlight }">
    <div class="ka-kpi__top">
      <span class="ka-kpi__title">{{ title }}</span>
      <div v-if="icon" class="ka-kpi__icon-wrap" :style="iconWrapStyle">
        <feather-icon :icon="icon" svgClasses="ka-kpi__icon" :style="{ color: highlight ? '#fff' : iconColor }" />
      </div>
    </div>
    <div class="ka-kpi__value">{{ value }}</div>
    <div class="ka-kpi__caption">{{ caption }}</div>
  </div>
</template>

<script>
export default {
  name: "KioskKpiCard",
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    caption: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "#6366F1" },
    highlight: { type: Boolean, default: false },
  },
  computed: {
    iconWrapStyle() {
      if (this.highlight) return { background: "rgba(255, 255, 255, 0.2)" };
      const hex = String(this.iconColor).replace("#", "");
      const r = parseInt(hex.slice(0, 2), 16) || 99;
      const g = parseInt(hex.slice(2, 4), 16) || 102;
      const b = parseInt(hex.slice(4, 6), 16) || 241;
      return { background: `rgba(${r}, ${g}, ${b}, 0.12)` };
    },
  },
};
</script>

<style scoped lang="scss">
.ka-kpi {
  background: #fff;
  border-radius: 18px;
  padding: 1.15rem 1.25rem;
  border: 1px solid #ececf2;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  min-height: 128px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;

  &--highlight {
    background: linear-gradient(128.53deg, #0f9d58 0%, #16a34a 100%);
    border-color: transparent;

    .ka-kpi__title,
    .ka-kpi__value,
    .ka-kpi__caption {
      color: #fff;
    }

    .ka-kpi__caption {
      opacity: 0.85;
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    line-height: 1.3;
  }

  &__icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__icon {
    width: 16px;
    height: 16px;
  }

  &__value {
    margin-top: auto;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.04em;
    color: #16172b;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__caption {
    margin-top: 0.45rem;
    min-height: 1.3em;
    font-size: 0.75rem;
    color: #a8a8b3;
    line-height: 1.3;
  }
}
</style>
